import React, { useContext, useEffect, useState } from 'react'
import { formatDate, ROUTES } from '../../shared/constants'
import { useHistory } from 'react-router'
import CustomTableLayout from '../../components/CustomComponents/CustomTableLayout'
import { useDownload } from '../../hooks/Download/useDownload'
import { CompanyConfigContext } from '../../context api/Configuration/CompanyConfig'
import { useModuleAdmins } from '../../hooks/Authentication/useModuleAdmins'

export default function ModuleAdmins() {
  const { getAllModuleAdmins, deleteManyModuleAdmin, loading, paginate, updateModuleAdmin } = useModuleAdmins()
  const { downloadLoading, getPdfCsvData, pdfCsvData } = useDownload()
  const { moduleAdmins } = useContext(CompanyConfigContext)

  const history = useHistory()

  const [searchQuery, setSearchQuery] = useState('')
  const filterModuleAdmin = moduleAdmins
  const [page, setPage] = React.useState(1)

  const noOfPages = paginate && paginate.totalPage
  useEffect(() => {
    getAllModuleAdmins({
      page: page,
      limit: 10,
      searchQuery,
    })
  }, [page, searchQuery])

  useEffect(() => {
    getPdfCsvData('GET_ALL_MODULEADMINS')
  }, [])

  const handleChange = (event, value) => setPage(value)

  const tempHeaders = [{ label: 'moduleAdminCode' }, { label: 'name' }]

  const handleSwitchChange = (item) => updateModuleAdmin({ ...item, active: !item.active, moduleAdminId: item._id })

  let tableBody = []

  if (!loading && filterModuleAdmin.length > 0) {
    tableBody = filterModuleAdmin.map((item) => {
      return [
        { type: 'CHECKBOX', _id: item._id },
        { value: item.moduleAdminCode },
        { value: `${item.firstName} ${item.lastName}` },
        { value: item.email },
        { value: item.phoneNumber },
        { type: 'STATUS', ...item },
        { type: 'INFO', onClick: () => history.push(`/view-moduleAdmin/${item._id}`) },
      ]
    })
  }

  const layoutProps = {
    heading: 'Manage ModuleAdmins',
    url: ROUTES.ADD_MODULEADMIN,
    editUrl: `/edit-moduleAdmin/`,
    searchQuery: searchQuery,
    setSearchQuery: setSearchQuery,
    tempHeaders: tempHeaders,
    tempHeaderData: [],
    filename: 'moduleAdmins',
    sampleName: 'sample_moduleAdmins',
    sheetName: 'moduleAdmin',
    headers: pdfCsvData.headings,
    data: pdfCsvData.headingValues,
    downloadLoading,
  }

  return (
    <CustomTableLayout
      tableHeadings={['ModuleAdmin Code', 'Name', 'Email', 'Mobile', 'Status', 'Info']}
      loading={loading}
      tableBody={tableBody}
      handleSwitchChange={handleSwitchChange}
      handlePageChange={handleChange}
      paginate={{ totalPage: noOfPages, page: page }}
      layoutProps={layoutProps}
      checkbox
      deleteMany={(val, setSelected) => deleteManyModuleAdmin({ moduleAdminId: val }, setSelected)}
    />
  )
}
